<template>
  <div class="d-flex justify-space-between">
    <div class="flex-1">
      <div class="font-weight-medium text-4">
        About {{ vaultInfo.text }}
      </div>
      <div class="mt-4 text-5 font-weight-light line-height-25">
        <p v-html="vaultInfo.tokenDescription"></p>
      </div>
    </div>
    <div class="ml-10 d-none d-md-block" style="width:160px">
      <!-- <div>
        <c-btn class="width-100" is-secondary>Buy</c-btn>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: ["vaultInfo"],
};
</script>
